import React, { useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Popover, Spin } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import DiagramaConversion, {
  AZUL_BIWO,
  AZUL_BIWO_BG,
  LIMA_BIWO,
  LIMA_BIWO_BG,
} from "./DiagramaConversion";

const AyudaConversionBase = ({ insumo, cantidad, headersToken, empresaId }) => {
  const [loading, setLoading] = useState(false);
  const [detalle, setDetalle] = useState(null);
  const [consultado, setConsultado] = useState(false);

  const conversion = parseFloat(insumo?.conversion);
  if (!insumo || isNaN(conversion)) {
    return null;
  }

  const consultarDetalle = () => {
    if (consultado || loading || !insumo._id) return;
    setLoading(true);
    axios
      .post(
        "insumos/obtenerRelacionPorId",
        { relacionId: insumo._id, empresaId },
        { headers: headersToken }
      )
      .then((res) => {
        setLoading(false);
        setConsultado(true);
        if (res.data.success === 2 && res.data.data) {
          setDetalle(res.data.data);
        }
      })
      .catch(() => {
        setLoading(false);
        setConsultado(true);
      });
  };

  const unidadProveedor =
    [detalle?.claveUnidad, detalle?.nombreUnidadProveedor].filter(Boolean).join(" - ") ||
    detalle?.unidadInformativa ||
    "unidad de compra";

  const unidadInventario =
    [detalle?.unidadSatInsumo, detalle?.nombreUnidadInventario].filter(Boolean).join(" - ") ||
    "unidad de inventario";

  const tieneDatosBase = detalle?.conversionProveedor > 0 && detalle?.conversionInventario > 0;

  const proveedorGenerico = conversion >= 1 || conversion <= 0 ? 1 : Math.round((1 / conversion) * 100) / 100;
  const inventarioGenerico = conversion >= 1 || conversion <= 0 ? conversion : 1;

  const cantidadNum = parseFloat(cantidad);
  const tieneProyeccion = !isNaN(cantidadNum) && cantidadNum > 0;
  const totalProyectado = tieneProyeccion ? cantidadNum * conversion : 0;

  const contenido = (
    <Spin spinning={loading}>
      <DiagramaConversion
        cajaA={{
          titulo: "El proveedor entrega",
          cantidad: tieneDatosBase ? detalle.conversionProveedor : proveedorGenerico,
          unidad: unidadProveedor,
          color: AZUL_BIWO,
          fondo: AZUL_BIWO_BG,
        }}
        cajaB={{
          titulo: "Das de alta en inventario",
          cantidad: tieneDatosBase ? detalle.conversionInventario : inventarioGenerico,
          unidad: unidadInventario,
          color: LIMA_BIWO,
          fondo: LIMA_BIWO_BG,
        }}
        factorTexto={
          <>
            Factor de conversión: <strong>{conversion.toFixed(4)}</strong>
          </>
        }
        notaTexto={
          tieneProyeccion && (
            <>
              Capturaste <strong>{cantidadNum}</strong> {tieneDatosBase ? unidadProveedor : "unidad(es)"} →
              recibirás{" "}
              <strong style={{ color: AZUL_BIWO }}>
                {totalProyectado.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 4,
                })}
              </strong>{" "}
              {unidadInventario} en inventario
            </>
          )
        }
      />
    </Spin>
  );

  return (
    <Popover
      content={contenido}
      title="Cómo funciona esta conversión"
      trigger="hover"
      overlayInnerStyle={{ width: 312 }}
      onVisibleChange={(visible) => visible && consultarDetalle()}
    >
      <QuestionCircleOutlined
        style={{ cursor: "pointer", color: "#8c8c8c", marginLeft: 4 }}
        onClick={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
      />
    </Popover>
  );
};

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AyudaConversionBase);
